<template>
    <div ref="container"  style='width: 100%' class="container d-flex flex-column h-100">
        <div>
            <header class="text-center">
                <div class="header-icon header-icon--login"></div>
                <!-- <img v-if='staff' src="/img/icon-login.svg" class="header-icon"> -->
                <!-- <img src="/img/egl/lock-standard3.svg" alt="" class="header-icon"> -->
                <h1 v-if='$route.params.new' class="h2">{{ $t('translations.create_your_password')}}</h1>
                <h1 v-else class="h2">{{ $t('translations.reset_your_password')}}</h1>
                <!-- <p>Enter the email address that you registered with, then check your email for a reset link</p> -->
            </header>

            <div class="card-default container mx-auto">
                <local-error v-bind:inline='["email", "password", "dob"]'></local-error>

                <form v-if='this.$route.params.token'>
                    <div class="form-group">

                        <label for="email">{{ $t('translations.email_address')}}</label>
                        <input autocomplete="off" class="form-control" type="email" name="email" id="email" v-model="auth.email" required>
                        <inline-error type='email'></inline-error>
                        <template v-if='$route.params.new == 1'>
                            <label>{{ $t('translations.date_of_birth')}}</label>
                            <!-- <input type="date" class="form-control" v-model='item.dob'> -->
                            <!-- <div class="form-row">
                                <div class="col">{{ $t('translations.day')}}<input v-model='auth.dob_day' type="number" min="01" class="form-control" placeholder="DD"></div>
                                <div class="col">{{ $t('translations.month')}}<input v-model='auth.dob_month' type="number" min="1" class="form-control" placeholder="MM"></div>
                                <div class="col">{{ $t('translations.year')}}<input v-model='auth.dob_year' type="number" min="1900" class="form-control" placeholder="YYYY"></div>
                            </div> -->
                            <vue-dob-picker show-labels='true' v-model='dob' />
                            <inline-error type='dob'></inline-error>
                        </template>
                        <password v-bind:errors='errors' v-bind:email='auth.email' v-bind:passwordfield.sync='auth.password'></password>
                    </div>

                    <div class="">
                        <button v-on:click.prevent='resetPassword()' class="btn btn-primary btn-block btn-round mt-2">
                            {{ $t('translations.reset_password')}}
                        </button>
                    </div>
                </form>

                <form v-else>
					<div v-if='linked_account_message' class='m-3 alert alert-warning text-dark'>
						{{ this.autobrand(linked_account_message) }}
					</div>

                    <div class="form-group">
                        <label for="email">{{ $t('translations.email_address')}}</label>
                        <input autocomplete="off" class="form-control" type="email" name="email" id="email" v-model="auth.email" required>
                        <inline-error type='email'></inline-error>
                    </div>

                    <div class="">
                        <button v-on:click.prevent='sendPasswordResetLink()' class="btn btn-primary btn-block btn-round mt-2">
                            {{ $t('translations.send_password_reset_link')}}
                        </button>
                    </div>
                </form>
            </div>
        </div>
        <div v-if='tBrandSetting("conf_show_licence_agreement")' class="mt-auto w-100 p-2">
            <p class="text-center"><strong><a target="_blank" href="https://askmygp.uk/about-us/askmygp-end-user-licence-agreement-eula/">{{ $t('translations.terms_of_use') }}</a></strong></p>
        </div>
        <div v-else class="pb-5"></div>
    </div><!--ref:container-->


</template>

<script>
var moment = require('moment');
export default {
    props: {
        returnpath: {},
        staff: {default: false},
        linked_account_message: "",
    },
    data: function(){
        return {
            auth: {
                token: "",
                //email: this.$route.params.email,
                email: "",
                password: "",
                // dob_year: "",
                // dob_month: "",
                // dob_day: "",
            },
            dob: null,
            errors: [],
        }
    },
    mounted() {
        this.logoutUser();
    },
    methods: {
        logoutUser() {
            this.setLoading(true);
            window.api_token = null;
            this.$root.api_token = window.api_token;

            if(window.Echo) {
                delete window.Echo.connector.options.auth.headers['Authorization'];
                delete axios.defaults.headers.common['Authorization'];
            }

            axios.get('/logout', this.auth).then((res) => {
                this.setLoading(false);
                //console.log(res.data);
            }).catch((error) => {
                this.setLoading(false);
            });
        },
        sendPasswordResetLink() {
            this.setLoading(true);
            axios.post('/api/vp1/auth/sendResetLinkEmail', this.auth).then((res) => {
                this.setLoading(false);
                this.addNotification({type: "success", content: this.$t('translations.password_reset_email_sent') });
                window.api_token = res.data.api_token;
                this.$root.api_token = window.api_token;
                if(window.Echo) {
                    window.Echo.connector.options.auth.headers['Authorization'] = 'Bearer ' + window.api_token;
                }
                if(!this.$route.params.next) {
                    this.$route.params.next = "intro";
                }

                this.$router.push({path: "/login/" + this.$route.params.next + "/resetSent"});
                console.log(res.data);

            }).catch((error) => {
                this.setLoading(false);
                this.handleError(error, "reset");
            });
        },
        resetPassword() {
            this.auth.token = this.$route.params.token;
            this.setLoading(true);
            // if(this.$route.params.new) {
            //     this.auth.dob = "" + this.auth.dob_year.padStart(2, '0') + "-" + this.auth.dob_month.padStart(2, '0') + "-" + this.auth.dob_day.padStart(2, '0');
            // }
            this.auth.dob = this.dob;
            // console.log(this.auth.dob);
            // console.log(this.dob);
            axios.post('/api/vp1/auth/reset', this.auth).then((res) => {
                this.setLoading(false);
                this.addNotification({type: "success", content: this.$t('translations.password_reset_successfully') });
                window.api_token = res.data.api_token;
                this.$root.api_token = window.api_token;
                if(window.Echo) {
                    window.Echo.connector.options.auth.headers['Authorization'] = 'Bearer ' + window.api_token;
                }
                if(!this.$route.params.next) {
                    this.$route.params.next = "intro";
                }
                this.$router.push({path: "/login/" + this.$route.params.next + "/resetSuccess"});
                console.log(res.data);

            }).catch((error) => {
                this.setLoading(false);
                this.handleError(error, "reset");
            });
        },
    }
}
</script>
